export const user_token = localStorage.getItem('jigsawUser') && JSON.parse(localStorage.getItem('jigsawUser'));